// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "resources_assets_tabler_vendor_integration_src_js_main_js") return "backoffice/js/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};